import React, { useEffect } from 'react'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper';
import ExamScore from '../components/examsGeneralComponents/ExamScore'
import ExamFeedbackFields from '../components/examsGeneralComponents/ExamFeedbackFields'
import CustomExamFeedback from '../components/examsGeneralComponents/CustomExamFeedback'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    main: {
        width: '100%',
        height: 'auto',
        marginTop: 32,
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        borderRadius: 6,
        '@media (max-width: 1050px)': {
            margin: 0,
            borderRadius: 0,
            width: '90%',
            marginTop: 20,
            marginLeft: 20
        }
    },
    institutionName: {
        color: '#4D4F5C',
        fontSize: 26,
        textTransform: 'uppercase',
        fontWeight: 300,
        marginBottom: 28
    },
    boldName: {
        color: '#4E4D4D',
        fontSize: 22,
        fontWeight: 500,
        marginBottom: 16
    }
}));

const FormBody = styled.div`
    padding: 40px 80px;
    display: flex;
    flex-direction: column;
    @media(max-width: 1050px) {
        padding: 16px;
    }
  `

const ButtonBox = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px;
    font-size: 18px;
    border-top: 1px solid #e3e3e3;
    @media print {
        display: none
    }
`

const ExamFeedback = ({ data }) => {
    const classes = useStyles();

    useEffect(() => {
        window.MathJax.typeset()
    })

    return (
        <Paper elevation={3} className={classes.main}>
            <ExamScore 
                acertos={data.feedbackExame.porcentagemPorDisciplina}
                score={data.feedbackExame.score}
                correct={data.feedbackExame.totalDePerguntasCorretas}
                total={data.feedbackExame.totalDePerguntas}
                name={data.feedbackExame.usuario.nome}
                date={data.feedbackExame.dataRealizacao}
            />
            <FormBody>
                {data.feedbackExame.isProvaPersonalizada ?
                    <div>
                        <CustomExamFeedback filtros={data.feedbackExame.provaPersonalizada} />
                    </div>
                    : ((data?.feedbackExame?.instituicao?.nome) || !(data?.feedbackExame?.instituicao?.nome !== '')) ? (
                        <Typography variant="body1" component="body1"
                            className={classes.institutionName}>
                            {(data?.feedbackExame?.instituicao?.nome !== (undefined || '' || null)) ? (`${data?.feedbackExame?.instituicao?.nome}`) : false}
                            {(data?.feedbackExame?.descricao !== (undefined || '' || null)) ? (` - ${data?.feedbackExame?.descricao}`) : false}
                            {(data?.feedbackExame?.ano !== (undefined || '' || null)) ? (` - ${data?.feedbackExame?.ano}`) : false}
                        </Typography>
                    ) : false}
                <Typography variant="body1" component="body1" className={classes.boldName}>Resultado:</Typography>
                <ExamFeedbackFields perguntas={data.feedbackExame.perguntas} />
            </FormBody>
            <ButtonBox>
                <Button color="primary" style={{ fontSize: 18 }} component={Link} to="/atividades">Encerrar</Button>
            </ButtonBox>
        </Paper>
    )
}

export default ExamFeedback